import { Component, input, output, ViewEncapsulation } from '@angular/core';
import { Observable } from 'rxjs';
import { MatButton } from '@angular/material/button';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import { Department } from 'src/app/features/department/department.model';
import { Organization } from 'src/app/features/organization/organization-models';
import { AccessGroup } from 'src/app/features/access-groups/access-group.model';
import { TextSearchComponent } from 'src/app/shared/components/text-search/text-search.component';
import { AdmOrgTypeaheadComponent } from 'src/app/shared/components/adm-org-typeahead/adm-org-typeahead.component';
import { AdmDepTypeaheadComponent } from 'src/app/shared/components/adm-dep-typeahead/adm-dep-typeahead.component';
import { AdmAccessGroupTypeaheadComponent } from 'src/app/shared/components/adm-access-group-typeahead/ag-typeahead.component';
import { AdmPricePolicyTypeaheadComponent } from 'src/app/shared/components/adm-price-policy-typeahead/adm-price-policy-typeahead.component';
import { PricePolicy } from 'src/app/features/prices/price-policies/interfaces/price-policy';

@Component({
  selector: 'adm-charging-station-location-filters',
  templateUrl: './charging-station-location-filters.component.html',
  styleUrl: './charging-station-location-filters.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    TextSearchComponent,
    AdmOrgTypeaheadComponent,
    AdmDepTypeaheadComponent,
    AdmAccessGroupTypeaheadComponent,
    AdmPricePolicyTypeaheadComponent,
    MatTooltip,
    MatCheckbox,
    MatButton,
  ],
})
export class ChargingStationLocationFiltersComponent {
  searchText = input<string | null>(null);
  organizationId = input<number | null>(null);
  departmentId = input<number | null>(null);
  accessGroupIdentifier = input<string | null>(null);
  pricePolicyId = input<number | null>(null);
  locationsWithErrorsInSetup = input<boolean>(false);
  resetTrigger = input<{ reset: boolean }>({ reset: false });
  isPricePolicyViewer = input<boolean>(false);
  hiddenFilters = input<string[]>([]);

  search$ = output<Observable<string>>();
  organizationSelected = output<Organization | null>();
  departmentSelected = output<Department | null>();
  accessGroupSelected = output<AccessGroup | null>();
  pricePolicySelected = output<PricePolicy | null>();
  locationWithErrorFilterUpdated = output<boolean>();
  resetAllFilters = output<void>();

  isHidden(filter: string): boolean {
    return this.hiddenFilters().includes(filter);
  }

  onSearchInput(source: Observable<string>) {
    this.search$.emit(source);
  }

  onOrganizationSelected(organization: Organization | null) {
    this.organizationSelected.emit(organization);
  }

  onDepartmentSelected(department: Department | null) {
    this.departmentSelected.emit(department);
  }

  onAccessGroupSelected(accessGroup: AccessGroup | null) {
    this.accessGroupSelected.emit(accessGroup);
  }

  onPricePolicySelected(pricePolicy: PricePolicy | null) {
    this.pricePolicySelected.emit(pricePolicy);
  }

  updateLocationWithErrorFilter(checked: boolean) {
    this.locationWithErrorFilterUpdated.emit(checked);
  }

  onResetAllFilters() {
    this.resetAllFilters.emit();
  }
}
